import { useTranslation } from 'react-i18next'
import ISO6391 from 'iso-639-1'
import InputFormikAutocomplete from '@/views/components/input-formik-autocomplete/index.component'

export const LanguagePersonalInfo = () => {
  const { t } = useTranslation()

  return (
    <InputFormikAutocomplete
      name="language"
      label={t('labels.language')}
      options={ISO6391.getAllCodes() || []}
      getOptionLabel={(option) => ISO6391.getName(option.toLowerCase())}
    />
  )
}
